import axios from 'axios';
import dayjs from 'dayjs';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const ICON = {
    'article': 'fa-newspaper',
    'image': 'fa-image',
    'video': 'fa-video',
    'reactive_video': 'fa-film',
    'audio': 'fa-volume-up',
    'reactive_audio': 'fa-microphone',
    'call_event': 'fa-phone',
    'sms_event': 'fa-comments',
    'post_event': 'fa-hashtag',
    'newsbanner': 'fa-bullhorn',
    'instruction': 'fa-exclamation-triangle',
    'post': 'fa-hashtag',
    'text': 'fa-quote-right'
}

const LBOX = {
    'article': 'ArticleLb',
    'image': 'ImageLb',
    'video': 'VideoLb',
    'reactive_video': 'ReactiveVideoLb',
    'audio': 'AudioLb',
    'reactive_audio': 'ReactiveAudioLb',
    'call_event': 'CallLb',
    'sms_event': 'SMSLb',
    'post_event': 'PostLb',
    'newsbanner': 'NewsbannerLb',
    'instruction': 'InstructionLb',
}

const GCOLORS = [
    '#bd467c',
    '#42b983',
    '#0c85b7',
    '#f37a48'
]

const ICOLORS = [
    '#FFAC81',
    '#FF928B',
    '#FEC3A6',
    '#EFE9AE',
    '#CDEAC0',
    '#abc4ff',
    '#DDA0DD'
]

export const NON_TIMELINE_CONTENT = [
    'instruction',
    'newsbanner',
    'sms_event',
    'call_event',
    'reactive_audio'
]

const checkData = data => Array.isArray(data) ? data : [data]

export default new Vuex.Store({
    state: {
        sections: [],
        pgroups: [],
        ugroups: [],
        users: [],
        gamemaster: {},
        files: {},
        texts: {},
        library: [],
        folders: [],
        title: "",
        preview: 0,
        init_preview: 0,
        game_running: null,
        game_pin: null,
        pgroup_filter: [],
        curr_project: null,
        curr_instance: null,
        language: "da",
        curr_pgroup: {},
        ICONS: ICON,
        LBOXES: LBOX,
        ICOLORS: ICOLORS,
        start_time_ts: null,
        pause_time_ts: null,
        connected: false,
        lib_posts: [],
        pub_posts: [],
        twitter_auth: "",
        user_logs: [],
        media_skins: [],
        roles: [],
        pgroup_content: [],
        comm_selected: {},
        launched_events: []
        // images: []
    },
    mutations: {
        // Need to use Vue.set() to assign to objects/arrays and keep them reactive
        // https://vuejs.org/v2/guide/list.html#Caveats
        // https://vuejs.org/v2/guide/reactivity.html

        // General
        setCurrProject: (state, curr_project) => (state.curr_project = curr_project),
        setCurrInstance: (state, curr_instance) => (state.curr_instance = curr_instance),
        setCurrPgroup: (state, curr_pgroup) => (state.curr_pgroup = curr_pgroup),
        setStartTime: (state, start_time) => state.start_time_ts = start_time,
        setPauseTime: (state, pause_time_ts) => state.pause_time_ts = pause_time_ts,
        setCurrPreview: (state, content_id) => (state.preview = content_id),
        setInitPreview: (state, content_id) => (state.init_preview = content_id),
        setGamemaster: (state, gamemaster) => (state.gamemaster = gamemaster),
        setGameStatus: (state, running) => (state.game_running = running),
        setGamePin: (state, game_pin) => (state.game_pin = game_pin),
        setCommSelected: (state, comm_selected) => (state.comm_selected = comm_selected),
        setTitle: (state, title) => (state.title = title),
        setTwitterAuth: (state, auth) => (state.twitter_auth = auth),
        setUserLogs: (state, logs) => (state.user_logs = logs),
        setMediaSkins: (state, skins) => (state.media_skins = skins),
        setConnected: (state, connected) => (state.connected = connected),
        setLaunchedEvents: (state, launched) => (state.launched_events = launched),
        setLanguage: (state, language) => (state.language = language),

        // Roles
        setRoles: (state, roles) => (state.roles = roles),
        addRole: (state, role) => (state.roles.push(role)),
        removeRole: (state, role_id) => Vue.delete(state.roles, state.roles.findIndex(r => r.role_id === role_id)),
        setRoleAttr: (state, { role_id, attr, val }) => {
            let index = state.roles.findIndex(x => x.role_id === role_id)
            Vue.set(state.roles[index], attr, val)
        },
        removeRoleUser: (state, { role_id, user_id }) => {
            let role_idx = state.roles.findIndex(r => r.role_id === role_id)
            let user_idx = state.roles[role_idx].users.findIndex(u => u === user_id)
            state.roles[role_idx].users.splice(user_idx, 1)
        },
        addRoleUser: (state, { role_id, user_id }) => {
            let role_idx = state.roles.findIndex(r => r.role_id === role_id)
            state.roles[role_idx].users.push(user_id)
        },

        // Timeline
        setSections: (state, sections) => (state.sections = sections.sort((a, b) => (a.index - b.index))),
        setSection: (state, { section_id, section }) => Vue.set(state.sections, state.sections.findIndex(s => s.section_id === section_id), section),
        setSectionDur: (state, { section_id, dur }) => {
            let idx = state.sections.findIndex(s => s.section_id === section_id)
            Vue.set(state.sections, idx, { ...state.sections[idx], duration: dur })
        },
        addSection: (state, section) => (state.sections.push(section)),
        removeSection: (state, section_id) => (state.sections = state.sections.filter(function (el) { return el.section_id != section_id })),
        setSectionContent: (state, { section_id, content }) => {
            content.map(x => x).forEach(function (c, i) { c.index = i })
            content = content.sort((a, b) => (a.index - b.index))
            let index = state.sections.findIndex(x => x.section_id === section_id)
            Vue.set(state.sections[index], 'content', content)
        },
        pushContent: (state, content) => {
            let sec_index = state.sections.findIndex(x => x.section_id === content.section_id)
            state.sections[sec_index].content.push(content)
        },
        setContent: (state, content) => {
            let sec_index = state.sections.findIndex(x => x.section_id === content.section_id)
            let cont_index = state.sections[sec_index].content.findIndex(x => x.content_id === content.content_id)
            Vue.set(state.sections[sec_index].content, cont_index, content)
        },
        setContentAttr: (state, { content_id, attr, val }) => {
            let sec_index = state.sections.findIndex(s => s.content.map(x => x.content_id).includes(content_id))
            let cont_index = state.sections[sec_index].content.findIndex(x => x.content_id === content_id)
            Vue.set(state.sections[sec_index].content[cont_index], attr, val)
        },
        setContentTimeOffset: (state, { section_id, content_id, time_offset }) => {
            let sec_index = state.sections.findIndex(x => x.section_id === section_id)
            let cont_index = state.sections[sec_index].content.findIndex(x => x.content_id === content_id)
            Vue.set(state.sections[sec_index].content[cont_index], 'time_offset', time_offset)
        },
        setParticipantGroupFilter: (state, pgroup_filter) => (state.pgroup_filter = pgroup_filter),

        // Users
        setUsers: (state, users) => (state.users = users),
        setUserName: (state, { user_id, name }) => {
            let index = state.users.findIndex(x => x.user_id === user_id)
            Vue.set(state.users[index], 'name', name)
        },
        setUserNumber: (state, { user_id, number }) => {
            let index = state.users.findIndex(x => x.user_id === user_id)
            Vue.set(state.users[index], 'number', number)
        },
        setUserParticipantGroups: (state, { user_id, pgroups }) => {
            let index = state.users.findIndex(x => x.user_id === user_id)
            Vue.set(state.users[index], 'pgroups', pgroups)
        },
        addUser: (state, user) => { state.users.push(user) },

        // Participant Groups
        setParticipantGroups: (state, pgroups) => (state.pgroups = pgroups.sort((a, b) => (a.index - b.index))),
        setParticipantGroupUsers: (state, { pgroup_id, users }) => {
            let index = state.pgroups.findIndex(x => x.pgroup_id == pgroup_id)
            Vue.set(state.pgroups[index], 'users', users)
        },
        setParticipantGroupPreview: (state, { pgroup_id, content_id }) => {
            let index = state.pgroups.findIndex(x => x.pgroup_id == pgroup_id)
            Vue.set(state.pgroups[index], 'curr_preview', content_id)
        },
        setParticipantPeerId: (state, { pgroup_id, peer_id }) => {
            let index = state.pgroups.findIndex(x => x.pgroup_id == pgroup_id)
            Vue.set(state.pgroups[index], 'peer_id', peer_id)
        },
        addParticipantGroup: (state, pgroup) => { state.pgroups.push(pgroup) },
        removeParticipantGroup: (state, pgroup_id) => {
            state.pgroups = state.pgroups.filter(function (el) { return el.pgroup_id != pgroup_id })
            state.users.forEach(function (user, index) {
                if (user.pgroups.includes(pgroup_id)) {
                    let g_index = user.pgroups.findIndex(x => x == pgroup_id)
                    state.users[index].pgroups.splice(g_index, 1)
                }
            })
        },
        setPgroupContent: (state, content) => { state.pgroup_content = content },
        setPgroupContentAttr: (state, { content_id, attr, val }) => {
            let index = state.pgroup_content.findIndex(x => x.content_id === content_id)
            Vue.set(state.pgroup_content[index], attr, val)
        },
        setPgroupContentData: (state, { content_id, data }) => {
            let index = state.pgroup_content.findIndex(x => x.content_id === content_id)
            Vue.set(state.pgroup_content[index], data)
        },

        // User Groups
        setUserGroups: (state, ugroups) => {
            state.ugroups = ugroups
        },
        setUserGroupUsers: (state, { ugroup_id, users }) => {
            let index = state.ugroups.findIndex(x => x.ugroup_id == ugroup_id)
            Vue.set(state.ugroups[index], 'users', users)
        },
        addUserGroup: (state, ugroup) => { state.ugroups.push(ugroup) },
        addUserGroupUser: (state, { ugroup_id, user_id }) => {
            let index = state.ugroups.findIndex(x => x.ugroup_id == ugroup_id)
            state.ugroups[index].users.push(user_id)
        },
        removeUserGroup: (state, ugroup_id) => {
            state.ugroups = state.ugroups.filter(function (el) { return el.ugroup_id != ugroup_id })
        },
        removeUser: (state, user_id) => {
            state.ugroups && state.ugroups.forEach((g, i) => {
                state.ugroups[i].users = g.users.filter(function (user) { return user != user_id })
            })
            state.pgroups && state.pgroups.forEach((g, i) => {
                state.pgroups[i].users = g.users.filter(function (user) { return user != user_id })
            })
        },

        // Files & texts / Library
        setLibrary: (state, library) => state.library = library,
        addLibraryItem: (state, lib_item) => state.library.push(lib_item),
        setLibraryItem: (state, lib_item) => {
            const index = state.library.findIndex(f => f.library_id == lib_item.library_id)
            const old_item = state.library[index]
            Vue.set(state.library, index, { ...old_item, ...lib_item })
        },
        setLibraryItemAttr: (state, { library_id, attr, val }) => {
            const index = state.library.findIndex(f => f.library_id == library_id)
            Vue.set(state.library[index], attr, val)
        },
        setFolders: (state, folders) => state.folders = folders,
        setFolder: (state, { folder_id, value }) => {
            const index = state.folders.findIndex(f => f.folder_id == folder_id)
            Vue.set(state.folders, index, value)
        },
        setFolderAttr: (state, { folder_id, attr, val }) => {
            const index = state.folders.findIndex(f => f.folder_id == folder_id)
            Vue.set(state.folders[index], attr, val)
        },
        addFolder: (state, folder) => state.folders.push(folder),
        removeFolder: (state, folder_id) => state.folders = state.folders.filter(f => f.folder_id != folder_id),
        setFiles: (state, files) => {
            state.files = {}
            files.forEach(f => {
                Vue.set(state.files, f.file_id, f)
            })
        },
        setTextAttr: (state, { text_id, attr, val }) => {
            Vue.set(state.texts[text_id], attr, val)
        },
        setTexts: (state, texts) => {
            state.texts = {}
            texts.forEach(t => {
                Vue.set(state.texts, t.text_id, t)
            })
        },
        setText: (state, { text_id, val }) => {
            Vue.set(state.texts, text_id, val)
        },
        addText: (state, text) => Vue.set(state.texts, text.text_id, text),
        deleteText: (state, text_id) => Vue.delete(state.texts, text_id),

        // Call and Msg logs
        addCallLog: (state, call) => {
            let idx = state.user_logs.findIndex(l => l.user_id == call.user_id)
            let c_idx = state.user_logs[idx].findIndex(c => c.sid == call.sid)
            if (c_idx != -1) Vue.set(state.user_logs[idx].calls, c_idx, call)
            else state.user_logs[idx].calls.push(call)
        },
        addMsgLog: (state, msg) => {
            let idx = state.user_logs.findIndex(l => l.user_id == msg.user_id)
            state.user_logs[idx].messages.push(msg)
        },

        // Social posts
        setLibPosts: (state, posts) => state.lib_posts = posts,
        setPubPosts: (state, posts) => state.pub_posts = posts,
        addPubPost: (state, post) => state.pub_posts.unshift(post),
        removePubPost: (state, post_id) => state.pub_posts = state.pub_posts.filter(t => t.post_id != post_id),

        // Events
        setLaunchedEventAttr: (state, { content_id, attr, val }) => {
            const idx = state.launched_events.findIndex(l => l.content_id === content_id)
            if (idx == -1) return
            Vue.set(state.launched_events[idx], attr, val)
        },
    },
    getters: {

        // Timeline
        getSections: (state) => (state.sections),
        getAllContent: (state) => (state.sections.map(s => s.content).flat().filter(Boolean)),
        getSectionContent: (state) => (section_id) => {
            let content = state.sections.find(x => x.section_id == section_id).content.map(x => x)
            content = content.sort((a, b) => (a.index - b.index))
            return content
        },
        getContent: (state, getters) => (content_id) => (getters.getAllContent.find(c => c.content_id === content_id)),
        getGameStatus: (state) => (state.game_running),
        getCurrPreview: (state) => (state.preview),
        getContentGroups: (state, getters) => (content_id) => (getters.getContent(content_id).pgroups),
        getParticipantGroupFilter: (state) => (state.pgroup_filter),
        getLibPosts: (state) => (state.lib_posts),
        getLibPost: (state) => post_id => (state.lib_posts.find(p => p.post_id == post_id)),
        getPubPosts: (state) => (state.pub_posts),
        getPubPost: (state) => post_id => (state.pub_posts.find(p => p.post_id == post_id)),
        getNewContentIndex: (state, getters) => section_id => {
            let content = getters.getSectionContent(section_id)
            if (content.length == 0) return 0
            return Math.max(...content.map(c => c.index)) + 1
        },
        getMediaSkins: (state) => (state.media_skins),
        getMediaSkinFileUrl: (state, getters) => (media_skin_id) => (getters.getFileUrl(
            state.media_skins.find(m => m.media_skin_id == media_skin_id).file_id)),

        // Roles
        getRoles: (state) => (state.roles),
        getRoleName: (state) => (role_id) => {
            let index = state.roles.findIndex(x => x.role_id === role_id)
            return state.roles[index].name
        },
        getRoleDescription: (state) => (role_id) => {
            let index = state.roles.findIndex(x => x.role_id === role_id)
            return state.roles[index].description
        },
        roleHasUser: (state) => (role_id, user_id) => {
            let index = state.roles.findIndex(x => x.role_id === role_id)
            return state.roles[index].users.includes(user_id)
        },
        getUserRoles: (state) => (user_id) => state.roles.filter(r => r.users.includes(user_id)),

        // Users
        getUsers: (state) => (state.users),
        getUser: (state) => (user_id) => (state.users.length > 0 ? state.users.find(x => x.user_id === user_id) : {}),
        getSortedLogs: state => type => state.user_logs
            .map(l => l[type].map(c => ({ ...c, datetime: dayjs(c.time) })))
            .flat()
            .sort((a, b) => a.datetime.valueOf() - b.datetime.valueOf),

        // Groups
        getParticipantGroups: (state) => (state.pgroups),
        getParticipantGroup: (state) => (pgroup_id) => (state.pgroups.find(g => g.pgroup_id == pgroup_id)),
        getParticipantGroupUserIds: (state) => (pgroup_id) => (state.pgroups.find(x => x.pgroup_id == pgroup_id).users),
        getParticipantGroupUsers: (state) => (pgroup_id) => {

            return pgroup_id
                ? Array.isArray(pgroup_id)
                    ? state.users.filter(u => u.pgroups.some(p => pgroup_id.includes(p)))
                    : state.users.filter(u => u.pgroups.includes(pgroup_id))
                : []
        },
        getParticipantGroupContent: (state, getters) => (pgroup_id) => (getters.getAllContent.filter(c => c.pgroups.includes(pgroup_id))),
        getParticipantGroupPeerId: state => pgroup_id => state.pgroups.find(pg => pg.pgroup_id == pgroup_id).peer_id,
        getUserGroups: (state) => (state.ugroups),
        getUserGroupUsers: (state) => (ugroup_id) => {
            let users = state.ugroups.find(x => x.ugroup_id == ugroup_id).users.map(x => x)
            users = users.sort((a, b) => (a - b)).sort(function (a, b) {
                if (a < 0 && b < 0) {
                    if (a < b) return 1
                    if (b < a) return -1
                }
                if (a < 0) return -1
                if (b < 0) return -1
                return 1
            })
            return users
        },
        getAvailableColor: (state) => {
            let pg_colors = state.pgroups.map(g => g.color)
            return GCOLORS.find(color => pg_colors.indexOf(color) == -1)
        },
        getGroupColor: (state) => (pgroup_id) => (state.pgroups.find(g => g.pgroup_id == pgroup_id).color),
        getUserParticipantGroups: (state) => (user_id) => {
            let groups = []
            state.pgroups.forEach(pgroup => {
                if (pgroup.users.find(u => u.user_id == user_id))
                    groups.push(pgroup.pgroup_id)
            })
            return groups
        },

        // Game PINs
        getGamePins: (state) => (state.pgroups.map(p => ({ pgroup_id: p.pgroup_id, pgroup_name: p.name, game_pin: p.game_pin, index: p.index })).sort((a, b) => (a.index - b.index))),

        // Files & texts / Library
        getLibrary: (state) => state.library,
        getLibraryItem: (state) => (library_id) => state.library.find(li => li.library_id == library_id),
        getFolders: (state) => state.folders,
        getFilesByType: (state) => (file_type) => (Object.values(state.files).filter(f => f.file_type === file_type)),
        getFile: (state) => (file_id) => (state.files[file_id]),
        getFileUrl: (state) => (file_id) => {
            let file = state.files[file_id]
            if (file) return state.files[file_id].url
            else return ""
        },
        getText: (state) => (text_id) => (state.texts[text_id]),
        getFiles: (state) => Object.values(state.files),
        getTextsObj: (state) => (state.texts),
        getAudios: (state) => Object.values(state.files).filter(f => f.file_type === 'audio'),
        getImages: (state) => Object.values(state.files).filter(f => f.file_type === 'image'),
        getVideos: (state) => Object.values(state.files).filter(f => f.file_type === 'video'),
        getCallTexts: (state) => Object.values(state.texts).filter(t => t.text_type === 'tts'),
        getSmsTexts: (state) => Object.values(state.texts).filter(t => t.text_type === 'sms'),
        getTexts: (state) => Object.values(state.texts).filter(t => t.text_type != 'note'),
        getNote: (state) => Object.values(state.texts).find(t => t.text_type === 'note' && t.instance_id === state.curr_instance && t.project_id === state.curr_project),

        // Events
        getLaunchedEvent: state => content_id => state.launched_events.find(l => l.content_id == content_id),
        // Duration and timing
        getTotalTime: (state) => state.sections.map(s => s.duration * 60).reduce((acc, val) => acc + val, 0),


    },
    actions: {

        // API Requests
        async fetchFiles({ commit, state }) {
            return axios
                .get("/api/projects/" + state.curr_project + "/files")
                .then(response => (commit('setFiles', checkData(response.data))))
        },
        async fetchTexts({ commit, state }) {
            return axios
                .get(state.curr_instance
                    ? '/api/instances/' + state.curr_instance + '/texts'
                    : '/api/projects/' + state.curr_project + '/texts')
                .then(response => {
                    const texts = state.curr_instance ?
                        response.data.filter(t => t.instance_id != null) :
                        response.data.filter(t => t.instance_id == null)
                    commit('setTexts', checkData(texts))
                })
        },
        async fetchUserGroups({ commit }) {
            return axios
                .get('/api/ugroups')
                .then(response => { commit('setUserGroups', checkData(response.data)) })
        },
        async fetchParticipantGroups({ commit, state }) {
            let url = "/api/" + (state.curr_instance ? "instances/" + state.curr_instance : "projects/" + state.curr_project) + "/pgroups"
            return axios
                .get(url)
                .then(response => { commit('setParticipantGroups', checkData(response.data)) })
        },
        async fetchUsers({ commit }) {
            return axios
                .get('/api/users')
                .then(response => { commit('setUsers', checkData(response.data)) })
        },
        async fetchProjectSections({ commit, state }) {
            return axios
                .get('/api/projects/' + state.curr_project + '/sections?template_only=true')
                .then(response => (commit('setSections', checkData(response.data))))
        },
        async fetchUserLogs({ commit, state }) {
            return axios
                .get('/api/instances/' + state.curr_instance + '/userlogs')
                .then(response => (commit('setUserLogs', checkData(response.data))))
        },
        async fetchPosts({ commit, state }) {
            return axios
                .get(state.curr_instance
                    ? '/api/instances/' + state.curr_instance + '/socialposts'
                    : '/api/projects/' + state.curr_project + '/socialposts')
                .then(response => {
                    const posts = state.curr_instance ?
                        response.data.filter(t => t.instance_id != null) :
                        response.data.filter(t => t.instance_id == null)
                    commit('setPubPosts', checkData(posts))
                })
        },
        async fetchLibrary({ commit, state }) {
            return axios
                .get(state.curr_instance
                    ? '/api/instances/' + state.curr_instance + '/library'
                    : '/api/projects/' + state.curr_project + '/library')
                .then(response => {
                    commit('setLibrary', checkData(response.data.filter(r => (
                        (r.item_type == 'text' ? r.text_type != 'note' : true) &&
                        (r.item_type == 'file' ? r.file_type != 'image/media_skin' : true)
                    ))))
                    commit('setFiles', checkData(response.data.filter(r => r.item_type === 'file')))
                    commit('setTexts', checkData(response.data.filter(r => r.item_type === 'text')))
                    commit('setLibPosts', checkData(response.data.filter(r => r.item_type === 'post')))
                })
        },
        async fetchFolders({ commit, state }) {
            return axios
                .get(state.curr_instance
                    ? '/api/instances/' + state.curr_instance + '/folders'
                    : '/api/projects/' + state.curr_project + '/folders')
                .then(response => {
                    commit('setFolders', checkData(response.data))
                })
        },
        async fetchMediaSkins({ commit, state }) {
            return axios
                .get('/api/projects/' + state.curr_project + '/mediaskins')
                .then(response => (commit('setMediaSkins', checkData(response.data))))
        },
        async fetchRoles({ commit, state }) {
            return axios
                .get('/api/' + (state.curr_instance ? "instances/" + state.curr_instance : "projects/" + state.curr_project) + '/roles')
                .then(response => commit('setRoles', checkData(response.data)))
        },
        async fetchPgroupContent({ commit, state }) {
            return axios
                .get('/api/games/' + state.game_pin + '/content')
                .then(response => commit('setPgroupContent', checkData(response.data.content)))
        },
        async fetchLaunchedEvents({ commit, state }) {
            return axios
                .get('/api/instances/' + state.curr_instance + "/launchedevents")
                .then(response => commit("setLaunchedEvents", checkData(response.data)))
        },
        async saveSection(commit, section) {
            return axios
                .put("/api/sections/" + section.section_id, section)
                .then(response => commit('setSection', { section_id: response.data.section_id, section: response.data }))
        },
        async saveContentMetadata(state, { content_id, payload }) {
            return axios
                .put("/api/content/" + content_id + "?metadata_only=true", payload)
        },

        async initProject({ commit, dispatch }) {
            return axios.get('/api/logged_in').then((response) => {
                if (response.data.role == 'guest') window.location.href = "/"
                commit('setGamemaster', response.data)
                dispatch('fetchUsers').then(() => {
                    dispatch('fetchUserGroups')
                })
            })
        },

        async initTimeline({ commit, state, dispatch }) {
            return axios.get('/api/logged_in').then(async response => {
                if (response.data.role == 'guest') window.location.href = "/"
                commit('setGamemaster', response.data)
                axios.all([
                    dispatch('refreshSections'),
                    dispatch('fetchUsers'),
                    dispatch('fetchParticipantGroups'),
                    dispatch('fetchUserGroups'),
                    dispatch('fetchMediaSkins'),
                    dispatch("fetchRoles"),
                    dispatch('fetchLibrary'),
                    dispatch('fetchFolders'),
                    dispatch('fetchPosts')
                ]).catch(err => { if (err.response.status == 404) window.location.href = "/404" })
                if (state.curr_instance) {
                    return axios.get("/api/instances/" + state.curr_instance).then(response => {
                        dispatch('fetchUserLogs')
                        dispatch('fetchLaunchedEvents')
                        commit('setGameStatus', Boolean(response.data.start_time_ts && !response.data.end_time_ts))
                        commit('setTitle', response.data.name)
                        commit('setTwitterAuth', response.data.twitter_auth)
                        commit('setLanguage', response.data.language)
                        return response.data
                    })
                }
                else {
                    dispatch('fetchProjectSections')
                    return axios.get('/api/projects/' + state.curr_project).then(response => {
                        commit('setTitle', response.data.name)
                        commit('setLanguage', response.data.language)
                    })
                }
            })
        },

        async initParticipant({ commit, state }) {
            return axios.get('/api/games/' + state.game_pin).then((response) => {
                let data = response.data
                commit('setGameStatus', data.running)
                commit('setCurrInstance', data.instance_id)
                commit('setCurrProject', data.project_id)
                commit('setCurrPgroup', data.pgroup)
                commit('setInitPreview', data.curr_preview && data.content.find(c => c.content_id == data.curr_preview).published ? data.curr_preview : null)
                commit('setMediaSkins', data.media_skins)
                commit('setFiles', data.files)
                commit('setRoles', data.roles)
                commit('setUsers', data.pgroup.users)
                commit('setTexts', data.texts)
                commit('setGamemaster', { gamemaster_id: data.gamemaster_id })
                commit('setLanguage', data.language)

                // Don't show other groups' posts
                commit('setPubPosts', data.social_posts.filter(p => p.pgroup_id == null || p.pgroup_id == data.pgroup.pgroup_id).reverse())

                if (!Array.isArray(data.content)) data.content = [data.content]
                commit('setPgroupContent', data.content)
            })
        },

        async refreshSections({ commit, state, dispatch }) {
            if (state.curr_instance)
                return axios.get("/api/instances/" + state.curr_instance + '/sections').then(response => { commit('setSections', response.data) })
            else
                return dispatch('fetchProjectSections')
        },

        addBlankUser: ({ commit }, { ugroup_id, user_id, name, number }) => {
            commit('addUser', {
                name: name,
                number: number,
                email: null,
                user_id: user_id,
                pgroups: []
            })
            commit('addUserGroupUser', {
                ugroup_id: ugroup_id,
                user_id: user_id
            })
        },
        addBlankUserGroup: ({ commit }, ugroup_id) => {
            commit('addUserGroup', {
                ugroup_id: ugroup_id,
                name: "",
                users: []
            })
        },
        addBlankParticipantGroup: ({ commit, getters }, pgroup_id) => {
            commit('addParticipantGroup', {
                pgroup_id: pgroup_id,
                name: "",
                users: [],
                color: getters.getAvailableColor
            })
        },
        addBlankRole: ({ commit }, role_id) => {
            commit('addRole', {
                role_id: role_id,
                title: "",
                description: "",
                users: []
            })
        },
        addBlankText: ({ commit }, { text_id, text_type }) => {
            commit('addText', {
                text_id: text_id,
                text: "",
                text_type: text_type,
            })
        },
        removeUserGroup: ({ commit, getters }, ugroup_id) => {
            let users = getters.getUserGroupUsers(ugroup_id)
            for (let user_id of users)
                commit('removeUser', user_id)
            commit('removeUserGroup', ugroup_id)
        }

    },
    strict: true
})